import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { fmtNum } from "./api";

const stamp = () => new Date().toISOString().slice(0, 16).replace(/[:T]/g, "-");

export function exportExcel(title, columns, rows) {
  const data = rows.map((r) => Object.fromEntries(columns.map((c) => [c.label, c.raw(r)])));
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, title.slice(0, 30).replace(/[\\/?*[\]:]/g, " "));
  XLSX.writeFile(wb, `${title.replace(/\s+/g, "_")}_${stamp()}.xlsx`);
}

export function exportPDF(title, columns, rows, { company = "KORIS GAMING DISTRIBUTION", subtitle = "", footer = "" } = {}) {
  const doc = new jsPDF({ orientation: columns.length > 6 ? "landscape" : "portrait", unit: "pt", format: "a4" });
  doc.setFontSize(13);
  doc.setTextColor(220, 30, 36);
  doc.text(company, 40, 40);
  doc.setTextColor(20, 20, 20);
  doc.setFontSize(11);
  doc.text(title, 40, 58);
  doc.setFontSize(8);
  doc.text(`${subtitle}  Édité le ${new Date().toLocaleString("fr-FR")}`, 40, 72);
  autoTable(doc, {
    startY: 84,
    head: [columns.map((c) => c.label)],
    body: rows.map((r) => columns.map((c) => {
      const v = c.raw(r);
      return typeof v === "number" ? fmtNum(v).replace(/\u202f|\u00a0/g, " ") : v ?? "";
    })),
    styles: { fontSize: 7, cellPadding: 3 },
    headStyles: { fillColor: [18, 18, 18], textColor: 255 },
    alternateRowStyles: { fillColor: [248, 245, 242] },
    didDrawPage: () => {
      if (footer) {
        doc.setFontSize(7);
        doc.text(footer, 40, doc.internal.pageSize.getHeight() - 20);
      }
    },
  });
  doc.save(`${title.replace(/\s+/g, "_")}_${stamp()}.pdf`);
}

const toDataUrl = async (url) => {
  const blob = await (await fetch(url)).blob();
  return new Promise((ok) => { const r = new FileReader(); r.onload = () => ok(r.result); r.readAsDataURL(blob); });
};

export async function printBon(bon) {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const W = doc.internal.pageSize.getWidth();
  try { doc.addImage(await toDataUrl("/logo-kgd.jpeg"), "JPEG", 40, 30, 90, 45); } catch (e) { console.warn("Logo non chargé sur le bon :", e?.message); }
  doc.setFontSize(10).setTextColor(220, 30, 36).text(bon.societe || "KORIS GAMING DISTRIBUTION", W - 40, 45, { align: "right" });
  doc.setTextColor(20, 20, 20).setFontSize(15).text(bon.titre, W / 2, 110, { align: "center" });
  doc.setFontSize(9);
  const info = [["Référence", bon.reference], ["Date", new Date(bon.date).toLocaleDateString("fr-FR")], ["Origine", bon.origine],
    ["Destination", bon.destination], ["Responsable", bon.responsable], ["Validé par", bon.valide_par || "—"]];
  autoTable(doc, { startY: 128, body: info, theme: "plain", styles: { fontSize: 9, cellPadding: 2 }, columnStyles: { 0: { fontStyle: "bold", cellWidth: 90 } } });
  autoTable(doc, {
    startY: doc.lastAutoTable.finalY + 14,
    head: [["N°", "Article", "Unité", "Quantité", "Observations"]],
    body: bon.lignes.map((l) => [l.numero, l.article, l.unite, fmtNum(l.quantite).replace(/\u202f|\u00a0/g, " "), l.observations]),
    foot: [["", "Total", "", fmtNum(bon.lignes.reduce((s, l) => s + Number(l.quantite), 0)).replace(/\u202f|\u00a0/g, " "), ""]],
    styles: { fontSize: 9, cellPadding: 4 }, headStyles: { fillColor: [18, 18, 18], textColor: 255 }, footStyles: { fillColor: [240, 236, 232], textColor: 20 },
    columnStyles: { 3: { halign: "right" } },
  });
  const y = doc.lastAutoTable.finalY + 50;
  ["Remis par", "Reçu par", "Visa KGD"].forEach((l, i) => {
    const x = 40 + i * ((W - 80) / 3);
    doc.setFontSize(9).text(l, x, y);
    doc.rect(x, y + 8, (W - 80) / 3 - 16, 60);
  });
  doc.setFontSize(7).text(`Édité le ${new Date().toLocaleString("fr-FR")}`, 40, doc.internal.pageSize.getHeight() - 20);
  doc.save(`${bon.titre.split(" ")[0]}_${bon.reference}_${stamp()}.pdf`);
}
